import React from 'react';

import Header from '../components/header';
import Calendar from '../components/calendar';
import MarketList from '../components/marketList';
import Footer from '../components/footer';
import Wrapper from './wrapper';

export default () => {
    return (
    <Wrapper>
        <Header />
        <Calendar />
        <MarketList /> 
        <Footer />
    </Wrapper>
    );
};
  